import { FILTER_GROUP_TO_QUERY_KEY_MAP } from '$lib/consts/filter';

export const HOME_URL = '/';

/**
 * A set with all allowed search param keys.
 */
export const ALLOWED_SEARCH_PARAMS = new Set<string>([
	// Compare mode ids
	'id',
	// Compare mode flag
	'compare',
	// Current selected date-range
	'daterange',
	// Current list mode
	'list',
	// The search query
	'search',
	// All filter params
	...Object.values(FILTER_GROUP_TO_QUERY_KEY_MAP)
]);

export const PAGES = {
	products: '/',
	details: '/detail',
	comparison: '/compare',
	portfolio: '/portfolio',
	documents: '/documents',
	transactions: '/transactions',
	opportunities: '/opportunities',
	contact: '/contact',
	glossary: '/glossary',
	faq: '/faq',
	activities: '/activities',
	market: '/market',
	personalData: '/personal-data',
	settings: '/settings',
	termsOfUse: '/terms-of-use'
};
